import React, { useContext } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui'

import {
    Grid,
    Card,
    CardContent,
    CardHeader,
    Typography
} from '@material-ui/core';

import { 
    Select,
    FieldError
} from '../../../../common'

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames } from '../../../../../helpers';

import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    invoiceAddress: {
        marginBottom: theme.spacing(2)
    }
}));

export const LogisticsDocumentationForm = (props) => {
    const classes: any = useStyles();

    const {
        state,
        getTableValues,
        getTableOptionsWithCode,
        getTransportationZoneOptions
    } = useContext(CustomerRequestContext)

    const { 
        values 
    } = useContext(TabsContext);

    const states = getTableValues(SapTableNames.States, values.dbType);

    return (
        <Card className={classes.card}>
            <CardHeader title="Logistics documentation"/>
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={12} md={12} xs={12}>
                        <Select
                            name="logisticDocumentation.transportationZoneId"                                               
                            label="Transportation Zone *"   
                            disabled={props.disabled}
                            options={getTransportationZoneOptions(values.primaryAddress.countryId, values.dbType)}
                        />
                        <FieldError name="logisticDocumentation.transportationZoneId" errors={state.errors} />
                    </Grid> 
                    <Grid item xl={6} md={12} xs={12}>
                        <Select
                            name="logisticDocumentation.incotermsId"
                            label="Incoterms *"
                            disabled={props.disabled}
                            options={getTableOptionsWithCode(SapTableNames.Incoterms, values.dbType)}
                        />
                        <FieldError name="logisticDocumentation.incotermsId" errors={state.errors} />
                    </Grid>
                    <Grid item xl={6} md={12} xs={12}>
                        <Field
                            className={classes.field}
                            variant="outlined"
                            type="text"
                            name="logisticDocumentation.incotermsLocation"
                            label="Incoterms location *"
                            disabled={props.disabled}
                            onInput={e => e.target.value = e.target.value.toUpperCase()}
                            component={TextField}
                        />
                        <FieldError name="logisticDocumentation.incotermsLocation" errors={state.errors} />
                    </Grid>                     
                    {values.isInvoceAddressDifferentFromCustomer
                        && values.invoiceAddresses && values.invoiceAddresses.length > 0 &&
                        <>
                            {values.invoiceAddresses.map((invAddress, index) => {
                                const stateId = invAddress.address.stateId;
                                // Be aware of react state (they share the same name)
                                const stateName = states.find(x => x.tableValueId === stateId).value;
                                return (
                                    <Grid key={index} item xl={12} md={12} xs={12}>
                                        <div className={classes.invoiceAddress}>
                                            <Typography variant="overline">
                                                {`${index}`}. Invoice Address&nbsp;
                                            </Typography>
                                            <Typography variant="caption">
                                                {`"${values.invoiceAddresses[index].shipName} - ${stateName}"`}
                                            </Typography>
                                        </div>
                                        <Select
                                            name={`invoiceAddresses[${index}].transportationZoneId`}
                                            label="Transportation Zone *"
                                            disabled={props.disabled}
                                            options={getTransportationZoneOptions(invAddress.address.countryId, values.dbType)}
                                        />
                                        <FieldError 
                                            name={`shippingTransportationZones[${index}].transportationZoneId`} 
                                            errors={state.errors} 
                                        />
                                    </Grid>
                                );
                            })}                                    
                        </>
                    }
                </Grid>
            </CardContent>
        </Card>
    );
}